import React from "react"
import { View, Text, Image, TouchableOpacity } from "react-native";
import { View as AnimatableView } from "react-native-animatable";

import { getImagePath } from "../../services/CommonUtils";

import { getCartTotalItemCount } from "../../services/oms/UpsertCartData";

import AppTheme from "../../../AppTheme";
import TextStyle from "../../../TextStyle";
import Colors from "../../constants/AppColors";

export const CartIconView = (props) => {

    const action = props.action

    const getCartItemCount = () => {
        if (props.cartItemCount)
            return props.cartItemCount
        else return getCartTotalItemCount()
    }

    return <AnimatableView animation="fadeIn" useNativeDriver
        style={{ alignItems: 'center', paddingLeft: 16, position: 'relative' }}
        duration={AppTheme.transitionDuration} delay={AppTheme.transitionDuration}>
        <TouchableOpacity onPress={() => action ? action() : null}>
            <Image style={{ marginVertical: 5, marginLeft: 4, width: 24, height: 24 }}
                source={{ uri: getImagePath('/images/icons/cart_black.svg') }} />
            {getCartItemCount() > 0 && <View style={{
                position: 'absolute', borderRadius: 8,
                top: 2, left: 20, width: 16, height: 15,
                backgroundColor: Colors.red.highlight,
            }}><Text style={[TextStyle.text10b, {
                color: 'white', textAlign: "center", alignItems: "center",
            }]}>{getCartItemCount()}</Text></View>}
        </TouchableOpacity></AnimatableView>
}

export const CartItemCountView = (props) => {
    const cartCount = props.cartCount
    return <Text style={[TextStyle.text9b, {
        right: -4, top: -4, width: 12, height: 12,
        color: 'white', textAlign: 'center', position: 'absolute',
        borderRadius: 6, backgroundColor: AppTheme.color.red.highlight,
    }]}>{cartCount}</Text>
}

export const CartIcon = () => { }


